<template>
    <div>
      <h3 class='text-bold' style="margin-bottom: 15px">{{$t('pages.profile.prompt')}}</h3>
      <div class='k6-box' style="margin-bottom: 15px;">
        <div class='k6-profile-image'>
          <img :src='profile.profilePhoto' alt="Profile image" />
        </div>
        <div class='k6-profile-data'>
          <div class='segment'>
            <span>@{{ profile.username }}</span>
            <h3 class="text-bold">{{ profile.firstName }} {{  profile.lastName }}</h3>
            <span>{{  profile.role }}</span>
          </div>
  
          <div class='segment segment-grid'>
              <span>{{$t("pages.profile.email")}}:</span>
              <span class="segment-data">{{ profile.email }}</span>
              <span>{{$t("pages.profile.studentId")}}:</span>
              <span class="segment-data">{{ profile.studentId }}</span>
          </div>
        </div>
        <div class='k6-profile-actions'>
          <button class='btn btn-success k6-btn' style="border-radius: 30px;" @click.prevent="goToEdit()">
            {{$t("pages.profile.edit")}} <i style='margin-left: 10px;' class='fa fa-pencil'></i>
          </button>
        </div>
      </div>

      <!--<div class='k6-box tabs' style='margin-top: 15px'>
        <h4 @click.prevent="setTabView('quizes')" :class="{ 'active-quizes': activeTab === 'quizes' }" class='text-bold'>
          {{ "Rezultati kvizov" }}
        </h4>
        <h4 @click.prevent="setTabView('exams')" :class="{ 'active-exams': activeTab === 'exams' }" class='text-bold'>
          {{ "Rezultati izpitov" }}
        </h4>
      </div>-->
  
    <div class="k6-profile-stats-container" v-if="quizes.length">
        <div class='k6-profile-cards'>
            <div v-for="quiz in quizes" class='k6-profile-card' :style="{backgroundColor: '#E7A03B', cursor: quiz.result !== null ? 'pointer' : 'default'}">
                <div class="card-data">
                    <h2 class="card-title">{{ quiz.title }}</h2>
                    <span>{{ quiz.date | formatDate }}</span>
                </div>
                <div style="font-size: 30px; font-weight: bold; margin-right: 5px;">
                    {{ quizResult(quiz.result) }}
                </div>
            </div>
        </div>
        <div class="graph">
          <div style="text-align: left; width: 100%; margin-top: 10px; margin-bottom: 10px">
            <h3 style="font-weight: bold; color: #444; font-size: 18px;">{{ $t("pages.profile.avgGrade") }}: 
              <span style="background-color: #E7A03B; color: white; padding: 5px; border-radius: 26px; padding-right: 10px; padding-left: 10px;">
                {{ avgGrade }} %
              </span>
            </h3>
          </div>
          <line-chart class="" :height="350" :width="500" :options="graphOptions" :chartData="chartData"></line-chart>
          
        </div>
    </div>
      
  
    </div>
  </template>
  
  <script>
  import Rest from './../../services/rest'
  import { mapGetters } from 'vuex'
  import router from './../../router/router'
  import Line from '@/charts/Line.js'

  export default {
    data () {
      return {
        profile: {id: '', username: '', email: '', firstName: '', lastName: '', studentId: '', language: '', allowUseOfMyResults: '', role: '', profilePhoto: ''},
        yearId: this.$route.params.yearId,
        uid: this.$route.params.uid,
        userId: this.$route.params.uid,
        activeTab: 'quizes',
        quizes: [],
        chartData: {},
        graphOptions: {
          scales: { yAxes: [{ ticks: {max: 100, min: 0} }] },
          tooltips: {
            callbacks: {
              title: function (tooltipItems, data) {
                const { label } = tooltipItems[0]
                return `${label}:`
              }
            }
          }
        }
      }
    },
    components: {
      'line-chart': Line
    },
    mounted: function () {
      this.prepareComponent()
    },
    computed: {
      ...mapGetters({
        pictureBaseURL: 'pictureBaseURL',
        avatarUrl: 'getLinkToAvatar'
      }),
      avgGrade () {
        let total = 0
        let count = 0
        this.quizes.forEach(quiz => {
          if (quiz.result !== null) {
            total += quiz.result
            count++
          }
        })

        return count > 0 ? (total / count).toFixed(1) : 0.0
      }
    },
    methods: {
      prepareComponent () {
        this.getData()
        this.getStats()
      },
      quizResult (grade) {
        return grade !== null ? `${grade}%` : ''
      },
      getData () {
        if (!this.uid) {
          this.userId = 'me'
        } else {
          this.getRoles()
        }
        Rest.request('GET', '/users/' + this.userId).then(data => {
          const { id, username, email, firstName, lastName, studentId, language, allowUseOfMyResults } = data
          this.profile = {
            ...this.profile, id, username, email, firstName, lastName, studentId, language, allowUseOfMyResults
          }
  
          if (data.roles.length > 0) {
            this.profile.role = data['roles'][0].displayName
          } else {
            // if no role -> student
            this.profile.role = this.$t('pages.profile.student')
          }
  
          if (data.profilePictureUrl === null) {
            this.profile.profilePhoto = this.avatarUrl
          } else {
            this.profile.profilePhoto = this.pictureBaseURL + data.profilePictureUrl
          }
        })
      },
      getStats: async function () {
        this.quizes = []
        const statsEndpoint = !this.uid ? `/users/statistics/grades/year/${this.yearId}` : `/users/${this.uid}/statistics/grades/year/${this.yearId}`
        const data = await Rest.request('GET', statsEndpoint)
        for (let i = 0; i < data.exams.length; i++) {
          this.quizes.push({
            title: data.exams[i].title,
            result: data.grades[0].grades[i],
            date: data.grades[0].dates[i]
          })
        }

        this.chartData = {
          labels: this.quizes.map(x => {
            return x.title.length > 10 ? x.title.substr(0, 10).trim() + ' ...' : x.title
          }),
          datasets: [{
            lineTension: 0,
            borderColor: '#E7A03B',
            label: this.$t('pages.profile.grade'),
            data: this.quizes.map(x => x.result),
            fill: false
          }]
        }
      },
      getRoles: function () {
        return Rest.request('GET', '/roles').then((data) => {
          this.roleList = data
        }).catch(function (err) {
          console.log(err)
        })
      },
      setTabView (tabName) {
        this.activeTab = tabName
      },
      goToEdit (userId) {
        router.push({name: 'profileEdit'})
      }
    }
  }
</script>
  
<style scoped>
  
  * {
    padding: 0;
    margin: 0;
  }
  
  .k6-box {
    padding: 30px;
    display: flex;
    justify-content: space-between;
    border-radius: 6px;
    background-color: #fff;
    gap: 20px;
  }
  
  .k6-box.tabs {
    margin-top: 10px;
    margin-bottom: 10px;
    width: fit-content;
    gap: 0px;
    padding: 0px;
    border-radius: 0px;
  }
  
  .k6-profile-image {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 150px;
  }
  
  .k6-profile-image img {
    width: 109px;
    height: 109px;
    border-radius: 100%;
    mix-blend-mode: normal;
    /*box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);*/
  }
  
  .k6-profile-data {
    flex: 1;
    display: flex;
    justify-content: flex;
    flex-direction: column;
    gap: 30px;
  }
  
  .segment {
    display: flex;
    flex-direction: column;
  }
  
  .segment-grid.segment {
    display: grid;
    grid-template-columns: 150px 1fr;
  }
  
  .k6-box.tabs > h4 {
    cursor: pointer;
    margin: 0;
    padding: 0;
    padding: 15px;
    padding-bottom: 10px;
    border-bottom: 5px solid transparent;
  }
  
  .k6-box.tabs > .active-quizes {
    color: #E7A03B;
    border-bottom: 5px solid #E7A03B;
  }

  .k6-box.tabs > .active-exams {
    color: #4AA362;
    border-bottom: 5px solid #4AA362;
  }

  .k6-profile-stats-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .k6-profile-stats-container > .graph {
    background-color: #fff;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 10em;
    aspect-ratio: 3/2;
    flex-direction: column;
    padding: 10px;
  }
  
  .k6-profile-cards {
    cursor: pointer;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .k6-profile-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    background-color: #4AA362;
    padding: 15px;
    color: #fff;
  }
  
  .k6-profile-card > .card-data {
    display: flex;
    flex-direction: column;
    gap: 5px;
    flex: 1;
  }
  
  .k6-profile-card .card-title,
  .text-bold {
      font-weight: bold;
  }
  
  .segment-data {
    color: #B1B1B1
  }
  
  .k6-btn {
    border-radius: 8px;
    background-color: #4AA362;
    border: 0;
    padding: 6px 12px !important;
  }
  
  @media only screen and (max-width: 767px) {
    .k6-box:not(.tabs) {
      flex-direction: column;
    }
  
    .k6-profile-cards {
      grid-template-columns: 1fr;
    }
  
    .k6-profile-image {
      width: 100%;
      margin-bottom: 20px;
    }
  
    .segment-grid.segment {
      display: grid;
      grid-template-columns: 1fr;
    }
  
    .segment-data {
      margin-bottom: 10px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .k6-profile-stats-container {
      grid-template-columns: 1fr;
    }
  }
</style>
  


// WEBPACK FOOTER //
// ProfileGroupStats.vue?49ac91ca